module.exports = __webpack_public_path__ + "static/media/beginner.67d0507a.PNG";